<template>
<div class="chapter">
<div class="inner_page">
<p class="htitle"><b><i>The Cross Timbers</i></b><br/><span class="small">MEMORIES OF A NORTH TEXAS BOYHOOD</span><a id="page_2"></a><a id="page_3"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292749214_10_htit1.vue?3b5cc523